import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-vidicon-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-xl font-semibold text-background-50">黄瓜视频</span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed mb-5">
                黄瓜视频是一款专注于短视频创作、分享与发现的平台。我们致力于为每一位创作者和观众提供最优质的内容体验。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-background-200 text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-background-200 text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-background-200 text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-background-200 text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-background-50 text-sm font-semibold mb-4">内容分类</h4>
              <div className="space-y-2.5">
                {categories.slice(0, 4).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-background-50 text-sm font-semibold mb-4">更多分类</h4>
              <div className="space-y-2.5">
                {categories.slice(4).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-background-50 text-sm font-semibold mb-4">关于我们</h4>
              <div className="space-y-2.5">
                <Link to="/about" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  品牌介绍
                </Link>
                <Link to="/about" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  用户口碑
                </Link>
                <Link to="/about" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  联系我们
                </Link>
                <a href="#" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  隐私政策
                </a>
                <a href="#" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  用户协议
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 黄瓜视频 huanggua.video 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-400 transition-colors">京ICP备XXXXXXXX号</a>
            <span className="mx-2">|</span>
            <a href="#" className="hover:text-primary-400 transition-colors">京公网安备XXXXXXXXXXXX号</a>
          </p>
        </div>
      </div>
    </footer>
  );
}